/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { referentialGetLanguages$Json } from '../fn/referential/referential-get-languages-json';
import { ReferentialGetLanguages$Json$Params } from '../fn/referential/referential-get-languages-json';
import { referentialGetLanguages$Plain } from '../fn/referential/referential-get-languages-plain';
import { ReferentialGetLanguages$Plain$Params } from '../fn/referential/referential-get-languages-plain';
import { referentialGetPagination$Json } from '../fn/referential/referential-get-pagination-json';
import { ReferentialGetPagination$Json$Params } from '../fn/referential/referential-get-pagination-json';
import { referentialGetPagination$Plain } from '../fn/referential/referential-get-pagination-plain';
import { ReferentialGetPagination$Plain$Params } from '../fn/referential/referential-get-pagination-plain';
import { referentialGetSessionTime$Json } from '../fn/referential/referential-get-session-time-json';
import { ReferentialGetSessionTime$Json$Params } from '../fn/referential/referential-get-session-time-json';
import { referentialGetSessionTime$Plain } from '../fn/referential/referential-get-session-time-plain';
import { ReferentialGetSessionTime$Plain$Params } from '../fn/referential/referential-get-session-time-plain';
import { RefLanguageDto } from '../models/ref-language-dto';

@Injectable({ providedIn: 'root' })
export class ReferentialService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `referentialGetLanguages()` */
  static readonly ReferentialGetLanguagesPath = '/v1/Referential/GetLanguages';

  /**
   * Get ref languages. Used at least by KIOSK_HOME and HOSPITAL (AllowAnonymous),   Permissions [AuthenticatedUser].
   *
   * It will return all ref languages
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `referentialGetLanguages$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  referentialGetLanguages$Plain$Response(params?: ReferentialGetLanguages$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<RefLanguageDto>>> {
    return referentialGetLanguages$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Get ref languages. Used at least by KIOSK_HOME and HOSPITAL (AllowAnonymous),   Permissions [AuthenticatedUser].
   *
   * It will return all ref languages
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `referentialGetLanguages$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  referentialGetLanguages$Plain(params?: ReferentialGetLanguages$Plain$Params, context?: HttpContext): Observable<Array<RefLanguageDto>> {
    return this.referentialGetLanguages$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<RefLanguageDto>>): Array<RefLanguageDto> => r.body)
    );
  }

  /**
   * Get ref languages. Used at least by KIOSK_HOME and HOSPITAL (AllowAnonymous),   Permissions [AuthenticatedUser].
   *
   * It will return all ref languages
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `referentialGetLanguages$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  referentialGetLanguages$Json$Response(params?: ReferentialGetLanguages$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<RefLanguageDto>>> {
    return referentialGetLanguages$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Get ref languages. Used at least by KIOSK_HOME and HOSPITAL (AllowAnonymous),   Permissions [AuthenticatedUser].
   *
   * It will return all ref languages
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `referentialGetLanguages$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  referentialGetLanguages$Json(params?: ReferentialGetLanguages$Json$Params, context?: HttpContext): Observable<Array<RefLanguageDto>> {
    return this.referentialGetLanguages$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<RefLanguageDto>>): Array<RefLanguageDto> => r.body)
    );
  }

  /** Path part for operation `referentialGetPagination()` */
  static readonly ReferentialGetPaginationPath = '/v1/Referential/GetPagination';

  /**
   * Get pagination in Ref technical codes (AllowAnonymous),   Permissions [AuthenticatedUser] ,   Restricted to [HOSPITAL].
   *
   * It will return the values of pagination (example : {5;10;15})
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `referentialGetPagination$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  referentialGetPagination$Plain$Response(params?: ReferentialGetPagination$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<any>>> {
    return referentialGetPagination$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Get pagination in Ref technical codes (AllowAnonymous),   Permissions [AuthenticatedUser] ,   Restricted to [HOSPITAL].
   *
   * It will return the values of pagination (example : {5;10;15})
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `referentialGetPagination$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  referentialGetPagination$Plain(params?: ReferentialGetPagination$Plain$Params, context?: HttpContext): Observable<Array<any>> {
    return this.referentialGetPagination$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<any>>): Array<any> => r.body)
    );
  }

  /**
   * Get pagination in Ref technical codes (AllowAnonymous),   Permissions [AuthenticatedUser] ,   Restricted to [HOSPITAL].
   *
   * It will return the values of pagination (example : {5;10;15})
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `referentialGetPagination$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  referentialGetPagination$Json$Response(params?: ReferentialGetPagination$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<any>>> {
    return referentialGetPagination$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Get pagination in Ref technical codes (AllowAnonymous),   Permissions [AuthenticatedUser] ,   Restricted to [HOSPITAL].
   *
   * It will return the values of pagination (example : {5;10;15})
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `referentialGetPagination$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  referentialGetPagination$Json(params?: ReferentialGetPagination$Json$Params, context?: HttpContext): Observable<Array<any>> {
    return this.referentialGetPagination$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<any>>): Array<any> => r.body)
    );
  }

  /** Path part for operation `referentialGetSessionTime()` */
  static readonly ReferentialGetSessionTimePath = '/v1/Referential/GetSessionTime';

  /**
   * Get Session expiration date for cookie used in MFA session (AllowAnonymous),   Permissions [AuthenticatedUser] ,   Restricted to [INSURER|ADMIN].
   *
   * <br />ACTION_CODE_POLICY: AuthenticatedUser
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `referentialGetSessionTime$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  referentialGetSessionTime$Plain$Response(params?: ReferentialGetSessionTime$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return referentialGetSessionTime$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Session expiration date for cookie used in MFA session (AllowAnonymous),   Permissions [AuthenticatedUser] ,   Restricted to [INSURER|ADMIN].
   *
   * <br />ACTION_CODE_POLICY: AuthenticatedUser
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `referentialGetSessionTime$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  referentialGetSessionTime$Plain(params?: ReferentialGetSessionTime$Plain$Params, context?: HttpContext): Observable<string> {
    return this.referentialGetSessionTime$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /**
   * Get Session expiration date for cookie used in MFA session (AllowAnonymous),   Permissions [AuthenticatedUser] ,   Restricted to [INSURER|ADMIN].
   *
   * <br />ACTION_CODE_POLICY: AuthenticatedUser
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `referentialGetSessionTime$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  referentialGetSessionTime$Json$Response(params?: ReferentialGetSessionTime$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return referentialGetSessionTime$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Session expiration date for cookie used in MFA session (AllowAnonymous),   Permissions [AuthenticatedUser] ,   Restricted to [INSURER|ADMIN].
   *
   * <br />ACTION_CODE_POLICY: AuthenticatedUser
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `referentialGetSessionTime$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  referentialGetSessionTime$Json(params?: ReferentialGetSessionTime$Json$Params, context?: HttpContext): Observable<string> {
    return this.referentialGetSessionTime$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

}
